import { useCosInfo } from "@/controllers/gridManager/accountsManager/accountManager";
import { getCopierInfo, getPNLHistoryFollower } from "@/controllers/gridManager/followerTransManager/followerTransManager";
import { formatDate } from "@/utilities";
import TableUIElement, { Column } from "@/views/components/componentsUI/TableUIElement";
import SelectElement, { ItemOption } from "@/views/elements/select/SelectElement";
import TypographyElement from "@/views/elements/typography/TypographyElement";
import { SelectChangeEvent } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {}

export default function PNLHistoryFollower({ }: Props) {
    const { t } = useTranslation()
    const { cosInfo } = useCosInfo()
    const { refaccount } = cosInfo
    const [listCopied, setListCopied] = useState<any[]>([])
    const [currentMasterAccount, setCurrentMasterAccount] = useState<string>('')

    const objParameterFn: Partial<Parameters<typeof getPNLHistoryFollower>[0]> = {
        accountId: refaccount,
        masterAccount: currentMasterAccount ?? '',
    }

    useEffect(() => {
        // hardcode
        async function callApiCopierInfo(accountId: string) {
            const { isSuccess, data } = await getCopierInfo({
                accountId: accountId
                , masterAccount: '' // get all
            })
            if (isSuccess) {
                console.log('ha_check_data', data)
                const listForOption: [] = data.map((item: any): Partial<ItemOption> => {
                    return {
                        label: item?.fullname ?? '',
                        value: item?.mtacctno ?? '',
                        ...item
                    }
                })
                const ALL: any[] = []// [{ label: 'ALL', value: '' }]
                setListCopied([...ALL, ...listForOption])
            }
        }

        if (refaccount) {
            callApiCopierInfo(refaccount)
        }
    }, [refaccount])

    const handleChangeCurrentMasterAccount = (event: SelectChangeEvent<any>) => {
        const value = event.target.value ?? ''
        setCurrentMasterAccount(value);
    };

    const columns: Column[] = [
        { id: 'txdate', label: t("copytrade.followerHistoryTransactions.txtDate"), enableSort: true, customRender: (value) => formatDate(value) },
        { id: 'symbol', label: t("copytrade.common.symbol"), alignCell: 'left', align: 'left' },
        { id: 'side', label: t("copytrade.followerHistoryTransactions.transType"), alignCell: 'left', align: 'left', customRender: (value) => renderSide(value) },
        { id: 'exec_qtty', label: t("copytrade.followerHistoryTransactions.qtty"), formatNumber: true, enableSort: true, alignCell: 'right', align: 'right' },
        { id: 'cost_price', label: t("copytrade.followerHistoryTransactions.costPrice"), formatNumber: true, enableSort: true, alignCell: 'right', align: 'right' },
        { id: 'quote_price', label: t("copytrade.followerHistoryTransactions.quotePrice"), formatNumber: true, enableSort: true, alignCell: 'right', align: 'right' },
        { id: 'pnl', label: t("copytrade.common.pnl"), formatNumber: true, isCheckPNL: true, enableSort: true, alignCell: 'right', align: 'right' },
        { id: 'ppnl', label: t("copytrade.common.ppnl"), cellFormula: (`(quote_price-cost_price)/cost_price*100`), cellSpecial: 'cost_price', formatNumber: true, isPercentage: true, isCheckPNL: true, enableSort: true, alignCell: 'right', align: 'right' },
    ];

    const renderSide = (side: string) => {
        return (<>
            {side === 'B' && <TypographyElement ColorElement="up">{t("copytrade.common.buy")}</TypographyElement>}
            {side === 'S' && <TypographyElement ColorElement="down">{t("copytrade.common.sell")}</TypographyElement>}
        </>)
    }

    const renderQuery = () => {
        return <>
            <SelectElement
                placeholder={t("copytrade.common.masterTrader")}
                listItems={listCopied}
                value={currentMasterAccount}
                onChange={handleChangeCurrentMasterAccount}
            />
        </>
    }

    return (
        <TableUIElement
            columns={columns}
            fnCallApi={getPNLHistoryFollower}
            objParameterFn={objParameterFn}
            enableDatePicker={true}

            queryBeforeDate={renderQuery}
            listenerQuery={{ currentMasterAccount }}
        />
    )
}